// Palette

export default {};
